import { useDarkMode } from "../../../context/ThemeContext";

interface ReportSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  disabled?: boolean;
  ariaLabel?: string;
}

export default function ReportSwitch({ checked, onChange, id, disabled, ariaLabel }: ReportSwitchProps) {
  const { isDarkMode } = useDarkMode();
  const trackOff = isDarkMode ? "bg-gray-600" : "bg-gray-300";

  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40 disabled:opacity-50 ${
        disabled ? "" : "cursor-pointer"
      } ${checked ? "bg-primary-500" : trackOff}`}
    >
      <span
        aria-hidden
        className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
          checked ? "translate-x-4" : "translate-x-0.5"
        }`}
      />
    </button>
  );
}
